export default __webpack_public_path__ + "static/media/empty_friend.aab6ffe7.png";